module.exports = __webpack_public_path__ + "img/group16_2x.354edc13.png";